import type { Product } from '@/types/products'
import { useMasterDataSync } from './useMasterDataSync'
import { useChannelImagesSync } from './useChannelImagesSync'
import { useDescriptionsSync } from './useDescriptionsSync'

/**
 * Orchestriert den Hintergrund-Sync beim Öffnen der Produktdetailseite:
 * Stammdaten/Preise (15-Min-Guard), Bilder über alle Channels (nur fehlende)
 * und Descriptions. Non-blocking; sub-hooks no-op bei fehlender id/product.
 * Gibt zurück, ob mindestens einer dieser Syncs gerade läuft — speist den
 * Sync-Indikator (spinnendes Icon) im Produkt-Hero.
 */
export function useProductOnOpenSync(productId: string | undefined, product: Product | undefined): boolean {
  const masterDataSyncing = useMasterDataSync(product)
  const imagesSyncing = useChannelImagesSync(productId)
  const descriptionsSyncing = useDescriptionsSync(productId)
  return masterDataSyncing || imagesSyncing || descriptionsSyncing
}
